import { Drawer } from "antd";

const SyncRuleStepDrawer = ({ open, setOpen }) => (
  <Drawer
    width={490}
    title="同步流程說明"
    open={open}
    onClose={() => setOpen(false)}
  >
    <div style={{ color: "#666" }}>
      達易僅將 ERP 中未開工的工單同步至 SFR
      系統，已開工或已完工的工單不會進行同步。
      <br />
      <br />
      因為 SFR
      系統從開工後就會開始追蹤工單的實際生產狀況，若將已開工的工單重新同步至 SFR
      系統，可能會導致數據不一致或覆蓋掉 SFR
      系統中的實際生產數據，影響生產追蹤和報表分析的準確性。
      <br />
      <br />
      同步時會依照以下規則進行 ERP 與 SFR 系統的數據匹配：
      <h4>數據匹配執行順序：</h4>
      <ol>
        <li>
          <strong>設備匹配：</strong>匹配小工單對應的設備或報工站
        </li>
        <li>
          <strong>員工匹配：</strong>匹配執行工序的員工資訊
        </li>
        <li>
          <strong>物料匹配：</strong>首先使用物料編號搜尋 SFR 中是否有對應的物料
        </li>
        <li>
          <strong>途程工序匹配：</strong>
          如果物料存在，比較該物料下的所有途程工序組合
        </li>
      </ol>
      <br />
      如果找不到符合匹配策略的記錄，系統會根據設定的自動新增策略來決定後續動作。
      <br />
      <h4>自動新增策略：</h4>
      <ul>
        <li>
          如果啟用自動新增，系統會根據 ERP 的資訊在 SFR 中創建對應的記錄，前提是
          ERP 中有所有必須提供的資訊，例如：員工編號和名稱等
        </li>
        <li>建議在正式環境啟用前先在測試環境驗證匹配規則</li>
      </ul>
    </div>
  </Drawer>
);

export default SyncRuleStepDrawer;
